import type { tripTypes } from '../../../constants/tripTypesConstants';
import { ONE_WAY } from '../../../constants/tripTypesConstants';
import type { RoutesType } from '../models';
import { convertDateStringOrTimestamp } from './dateUtils';

export const getReturnDate = (tripType: keyof typeof tripTypes, routes: RoutesType = []) => {
  return tripType === ONE_WAY
    ? null
    : new Date(convertDateStringOrTimestamp(routes[routes.length - 1]?.departureAt ?? ''));
};

export const getReturnTimeOfDay = (tripType: keyof typeof tripTypes, routes: RoutesType = []) =>
  tripType !== ONE_WAY ? routes[routes.length - 1]?.departureTimeOfDay : null;
